<template>
  <div
    v-loading="isLoading"
    class="materiral-image"
  >
    <div class="top-search">
      <div class="search-input">
        <mk-input
          v-model="name"
          :disabled="isBatch"
          width="240"
          clearable
          class="search-input"
          placeholder="输入图片名称"
          @keyup.enter.native="handleOnSearch"
          @clear="handleOnSearch"
        >
          <div
            slot="suffix"
            class="el-input__icon"
          >
            <i
              class="el-icon-search"
              @click="handleOnSearch"
            />
          </div>
        </mk-input>
        <mk-button-biz
          class="reset"
          icon="el-icon-search"
          size="small"
          type="primary"
          @click="handleOnSearch"
        >
          搜索
        </mk-button-biz>
        <mk-button-biz
          class="reset"
          size="small"
          @click="reset"
        >
          重置
        </mk-button-biz>
      </div>
      <div class="top-search-right">
        <!-- <mk-button-biz
          :disabled="isBatch || data.length === 0"
          class="batch cursor"
          @click="openBatchOp"
        >
          批 量
        </mk-button-biz> -->
        <mk-popover
          placement="left"
          trigger="hover"
          :visible-arrow="false"
          popper-class="courseware-manage-popover"
        >
          <div class="mention-text">
            <ds-iconfont icon-class="icon-ds-tishi" />支持JPG，JPEG，PNG格式的图片，大小不超过2MB
          </div>
          <mk-button-biz
            slot="reference"
            :disabled="isBatch"
            class="upload-button"
            height="32px"
            width="104px"
            type="primary"
            size="small"
            @click="uploadClick"
          >
            <ds-iconfont icon-class="icon-mk-upload" />
            上传图片
          </mk-button-biz>
        </mk-popover>
      </div>
    </div>
    <div class="img-list">
      <div
        v-for="(item,index) in data"
        :key="index"
        class="img-item"
      >
        <div>
          <div class="pic">
            <!-- quality: 图片质量 -->
            <!-- Q_90: 90% -->
            <!-- resize,w_600: 图片宽度 -->
            <mk-image
              ref="img"
              class="img"
              fit="cover"
              :src="item.url"
              :preview-src-list="[item.url]"
            >
            </mk-image>
            <div class="pic-hover-box">
              <mk-popover
                v-model="item.deletePop"
                placement="top"
                trigger="click"
                popper-class="courseware-manage-delete-confirm"
              >
                <div>
                  <div class="mention-text">
                    <ds-iconfont icon-class="icon-ds-tishi" />你确定删除这项素材吗？
                  </div>
                  <div class="button">
                    <mk-button-biz
                      width="50px"
                      height="24px"
                      @click="ordinaryDelete(item._id)"
                    >
                      删除
                    </mk-button-biz>
                    <mk-button-biz
                      width="50px"
                      height="24px"
                      type="primary"
                      @click="item.deletePop = false"
                    >
                      取消
                    </mk-button-biz>
                  </div>
                </div>
                <div
                  slot="reference"
                  class="delete-pic"
                >
                  删除
                </div>
              </mk-popover>
              <div
                class="preview-pic"
                @click="previewImg(index)"
              >
                预览
              </div>
            </div>
          </div>
          <div class="content-wrapper">
            <div class="name-wrapper">
              <mk-checkbox
                v-if="isBatch"
                v-model="item.checked"
              />
              <!-- <mk-tooltip
                effect="dark"
                content="点击编辑名称"
                placement="top"
                popper-class="courseware-manage-tooltip"
              >
                <span
                  v-show="!item.inputVisible"
                  class="name"
                >{{ item.name + '.' +item.suffix }}</span>
              </mk-tooltip> -->
              <span
                v-show="!item.inputVisible"
                class="name"
              >{{ item.name + '.' +item.suffix }}</span>
              <mk-input
                v-show="item.inputVisible"
                ref="changeNameInput"
                v-model="inputVal"
                maxlength="20"
                show-word-limit
                @blur="changeName(item, index)"
              ></mk-input>
            </div>
          </div>
        </div>
        <!-- 全选操作 覆盖层级 -->
        <div
          v-if="isBatch"
          class="cover-pic"
          @click="selectItem(item)"
        />
      </div>
      <no-data
        v-if="data.length === 0 && !isLoading"
        place-holder="暂无资料"
      />
    </div>
    <!-- 分页 -->
    <div
      v-if="!isBatch"
      class="pagination"
    >
      <mk-pagination
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
    <!-- 全选操作 -->
    <footer-toolbar
      v-if="isBatch"
      class="tag-batch-op-toolbar"
      :select-all="selectAll"
      :selection="currentSelection"
      @on-checked-change="handleOnCheckedChange"
      @on-remove-click="handleOnToolbarRemoveClick"
      @on-apply-click="handleOnToolbarApplyClick"
      @on-cancel-click="handleOnToolbarCloseClick"
    />
    <!-- 是否批量删除 -->
    <mk-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>是否删除选中图片</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleOnToolbarRemoveClickCenter"
        >确 定</el-button>
      </span>
    </mk-dialog>
    <muti-upload
      ref="upload"
      accept=".jpg,.png,.jpeg"
      :limit-size="2"
      :category="type"
      type="mba"
      @finish="onUploadFinish"
    ></muti-upload>
  </div>
</template>

<script>
import NoData from '@/components/no-data'
import CommonData from '../common'
import MutiUpload from '../muti-upload'

export default {
  name: 'MaterialImage',
  components: {
    MutiUpload,
    NoData
  },
  mixins: [CommonData],
  data () {
    return {
      type: 1
    }
  },
  methods: {
    // 预览图片
    previewImg (index) {
      this.$refs.img[index].$children[0].showViewer = true
    },
    // 重置
    reset () {
      this.name = ''
      this.onInput()
    }
  }
}
</script>

<style lang="scss" scoped>
.materiral-image {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ .el-image-viewer__wrapper {
    .el-image-viewer__btn {
      color: #fff;
      opacity: 1;
    }

    .el-image-viewer__canvas {
      img {
        max-width: 92% !important;
        max-height: 92% !important;
      }
    }
  }

  .top-search {
    padding: 10px 20px 0;
    position: relative;

    /deep/ .tag-select {
      display: inline-block;
      margin-right: 10px;
    }

    .top-search-right {
      position: absolute;
      right: 20px;
      top: 10px;

      .batch {
        border: 1px solid #ccecff;
        color: #1b9aee;
        font-size: 14px;
        line-height: 20px;
        margin-right: 10px;
        padding: 7px 14px;
        border-radius: 4px;
      }

      /deep/ .is-disabled {
        color: #d9d9d9;
        border: 1px solid #d9d9d9;
      }

      .upload-button {
        .icon-mk-upload {
          color: #fff;
          font-size: 13px;
        }
      }
    }
  }

  .img-list {
    height: 100%;
    padding-left: 20px;
    margin: 10px 0 0;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    flex: 1;
    align-content: flex-start;

    .img-item {
      margin: 0 20px 30px 0;
      position: relative;
      height: 300px;

      &:hover {
        box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.1);
      }

      .cover-pic {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
      }

      .pic {
        position: relative;
        width: 262px;
        height: 256px;
        border: 1px solid #e8e8e8;
        border-bottom: none;
        box-sizing: border-box;

        .img {
          width: 100%;
          height: 100%;
        }

        &:hover {
          .pic-hover-box {
            display: block;
          }
        }

        .pic-hover-box {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.7);

          .set-tag-pic {
            font-size: 13px;
            color: #fff;
            width: 64px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            position: absolute;
            top: 10px;
            right: 58px;
            border-radius: 2px;
            border: 1px solid rgba(255, 255, 255, 1);
          }

          .delete-pic {
            font-size: 13px;
            color: #fff;
            width: 38px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            position: absolute;
            top: 10px;
            right: 10px;
            border-radius: 2px;
            border: 1px solid rgba(255, 255, 255, 1);
            cursor: pointer;
          }

          .preview-pic {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 108px;
            height: 32px;
            color: #fff;
            text-align: center;
            line-height: 32px;
            font-size: 14px;
            background-color: hsla(0, 0%, 99.6%, 0.2);
            border-radius: 20px;
            border: 1px solid #fefefe;
            cursor: pointer;

            &:hover {
              background-color: #009cff;
              border-color: #009cff;
            }
          }
        }
      }

      .content-wrapper {
        border: 1px solid #e8e8e8;
        background-color: #fefefe;
        padding: 0 12px;
        width: 236px;

        .name-wrapper {
          box-sizing: border-box;
          width: 236px;
          height: 42px;
          line-height: 42px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          border-top: none;

          /deep/ .el-checkbox:last-of-type {
            margin-right: 10px;
          }
        }
      }

      .name {
        font-size: 14px;
        color: #262626;
        // cursor: pointer;

        // &:hover {
        //   color: #009cff;
        // }
      }
    }
  }

  .material-list {
    height: 100%;
    overflow-y: auto;
    margin-top: 20px;
    padding-left: 30px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 24px 20px;
    border-top: 1px solid #e8e8e8;

    .total {
      color: #6d7278;
      font-size: 13px;
    }

    .mk-pagination {
      margin-top: 0;
    }
  }

  .no-data {
    width: 100%;
  }

  .tag-select-cascader {
    margin-right: 10px;
  }

  .reset {
    margin-left: 10px;
  }

  .search-input {
    /deep/ .el-input__suffix {
      .el-input__clear {
        position: absolute;
        top: 0;
        left: -25px;
      }
    }
  }
}
</style>
